var reloadCount = 1;

function UpdateMontage(http_request)
{
	if ((http_request.readyState == 4) && (http_request.status == 200))
	{
		try
		{
			var Data = eval('(' + http_request.responseText + ')');
		}
		catch (e)
		{
			OverrideSaveCheck = true;
			document.write(http_request.responseText);
			return;
		}

		var Status = Data.Status;
		var Image = Data.Image;
		var Id = Data.Id;

		var AnalyzeLink = document.getElementById('AnalyzeLink');
		var MontageStatus = document.getElementById('MontageStatus');
		var AnalysisStatus = document.getElementById('AnalysisStatus');
		var MontageLink = document.getElementById('MontageLink');
		var MontageImage = document.getElementById('MontageImage');
		var MontageImageNA = document.getElementById('MontageImageNA');

		if (MontageStatus.innerHTML.replace(/^\\s+|\\s+$/g, '') != Status.Value.replace(/^\\s+|\\s+$/g, ''))
		{
			MontageStatus.innerHTML = Status.Value;
			MontageStatus.className = Status.Type;

			MontageLink.setAttribute('href', '#');
			MontageLink.setAttribute('ImageServerURL', Image.ImageServerURL);
			MontageLink.setAttribute('ImageId', Image.ImageId);
			if ((Status.Value == 'Montage Complete') || MontageIsInvalid(Status.Value))
			{
				MontageImage.setAttribute('src', Image.Source);
				MontageImage.style.display = '';
				MontageImageNA.style.display = 'none';
				AnalyzeLink.className = '$BulkClass';
				AnalyzeLink.href = 'AnalyzeSlides.php?ImageIds[]=' + Image.ImageId;
			}
			else
			{
				MontageImage.style.display = 'none';
				MontageImageNA.style.display = '';
				AnalyzeLink.className = 'BulkLinkDisabled';
			}
		}
		AnalysisStatus.innerHTML = Image.Analysis;
		AnalysisStatus.className = Image.AnalysisType;

		delete Data;

		var Cmd = "HTTPRequest ('/UpdateMontage.php?Id=" + Id + "', 'POST', '', UpdateMontage)";
		setTimeout(Cmd, 2000);
	}
}
